import React from 'react';

const FallingLeaves = () => {
  // SVG leaf icon
  const leafSVG = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%233f6d1a'%3E%3Cpath d='M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z'/%3E%3C/svg%3E`;
  
  return (
    <div className="falling-leaves-container">
      {[...Array(6)].map((_, i) => (
        <div 
          key={i} 
          className="falling-leaf"
          style={{
            backgroundImage: `url("${leafSVG}")`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat'
          }}
        />
      ))}
    </div>
  );
};

export default FallingLeaves;
